import makeStyles from 'transfix-ui/core/styles/makeStyles'

export const useCoverModalStyles = makeStyles(theme => ({
  body: {
    margin: `${theme.spacing(3)} 0 0`,
  },
  cancelButton: {
    position: 'absolute',
    top: theme.spacing(3),
    left: theme.spacing(3),
  },
  modalContainer: {
    width: '100%',
    '& .modal': {
      [theme.breakpoints.up('md')]: {
        width: '95%',
      },
      [theme.breakpoints.up('lg')]: {
        width: '75%',
      },
      [theme.breakpoints.up('xl')]: {
        width: '60%',
      },
    },
  },
  boxContainer: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    minHeight: '200px',
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
    },
  },
  spinnerContainer: {
    position: 'relative',
    height: '100%',
  },
  infoBox: {
    [theme.breakpoints.up('md')]: {
      flex: '0 0 50%',
    },
  },
  cardsBox: {
    [theme.breakpoints.up('md')]: {
      flex: '0 0 40%',
    },
  },
  trackingCardBox: {
    marginTop: theme.spacing(2),
  },
}))
